
{
  "familyId": "MET-HOEK-SOORTEN",
  "questions": [
    {
      "id": "MET-HOEK-SOORTEN-001",
      "familyId": "MET-HOEK-SOORTEN",
      "module": "Metriek",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "hoeken",
      "subSkill": "hoek_soorten",
      "questionType": "multiple_choice",
      "question": "Een timmerman zaagt een plank schuin af. De zaaghoek is 55°. Wat voor soort hoek is dat?",
      "options": ["een scherpe hoek", "een rechte hoek", "een stompe hoek", "een gestrekte hoek"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Hoeksoorten overzicht",
            "content": "Scherp: < 90° (spits, kleiner dan een rechte hoek)\nRecht: = 90° (vierkantje in de hoek)\nStomp: > 90° en < 180° (wijd, groter dan recht)\nGestrekt: = 180° (rechte lijn)",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "hoek_soorten_scherp",
      "variantIndex": 1,
      "citoDifficulty": 0.25,
      "citoDiscrimination": 0.76,
      "feedback": {
        "explanationText": "55° is kleiner dan 90°, dus het is een scherpe hoek. Scherpe hoeken zijn 'spits' — ze zijn kleiner dan een rechte hoek. Je kunt het onthouden door te denken aan een scherp mes: de punt maakt een kleine, spitse hoek. Controleer: 55° < 90° → scherp ✓.",
        "solutionSteps": [
          "Bekijk het getal: 55°",
          "Vergelijk met 90°: 55° < 90°",
          "Kleiner dan 90° = scherpe hoek",
          "Controleer: een scherpe hoek is spits, dat past bij 55° ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! 55° is kleiner dan 90°, dus het is een scherpe hoek.",
          "1": "Je dacht waarschijnlijk dat 55° een rechte hoek is. Maar een rechte hoek is precies 90°, en 55° is kleiner dan 90°. Onthoud: alleen exact 90° is recht — herken het aan het vierkantje.",
          "2": "Je dacht waarschijnlijk dat 55° een stompe hoek is. Maar een stompe hoek is groter dan 90°. 55° is juist kleiner dan 90°, dus scherp. Onthoud: stomp = wijd = groter dan 90°.",
          "3": "Je dacht waarschijnlijk dat 55° een gestrekte hoek is. Maar een gestrekte hoek is precies 180° — een rechte lijn. 55° is veel kleiner. Onthoud: gestrekt = 180° = een rechte lijn."
        }
      }
    },
    {
      "id": "MET-HOEK-SOORTEN-002",
      "familyId": "MET-HOEK-SOORTEN",
      "module": "Metriek",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "hoeken",
      "subSkill": "hoek_soorten",
      "questionType": "multiple_choice",
      "question": "Een dakdekker meet de hoek van een schuin dak. De hoek is 135°. Wat voor soort hoek is dat?",
      "options": ["een scherpe hoek", "een rechte hoek", "een stompe hoek", "een gestrekte hoek"],
      "correctAnswer": 2,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Hoeksoorten overzicht",
            "content": "Scherp: < 90° (spits, kleiner dan een rechte hoek)\nRecht: = 90° (vierkantje in de hoek)\nStomp: > 90° en < 180° (wijd, groter dan recht)\nGestrekt: = 180° (rechte lijn)",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "hoek_soorten_stomp",
      "variantIndex": 2,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "135° is groter dan 90° maar kleiner dan 180°, dus het is een stompe hoek. Onthoud: stomp = 'wijd' — de hoek is wijder dan een rechte hoek maar nog geen rechte lijn. Controleer: 90° < 135° < 180° → stomp ✓.",
        "solutionSteps": [
          "Bekijk het getal: 135°",
          "Vergelijk: 135° > 90° → niet scherp en niet recht",
          "Vergelijk: 135° < 180° → niet gestrekt",
          "Tussen 90° en 180° = stompe hoek ✓"
        ],
        "distractorExplanations": {
          "0": "Je dacht waarschijnlijk dat 135 graden een scherpe hoek is. Maar een scherpe hoek is kleiner dan 90 graden, en 135 is groter dan 90. Onthoud: scherp = spits = kleiner dan 90 graden.",
          "1": "Je dacht waarschijnlijk dat 135 graden een rechte hoek is. Maar een rechte hoek is precies 90 graden, en 135 is groter. Onthoud: alleen exact 90 graden is recht.",
          "2": "Goed! 135 graden ligt tussen 90 en 180 graden, dus het is een stompe hoek.",
          "3": "Je dacht waarschijnlijk dat 135 graden een gestrekte hoek is. Maar een gestrekte hoek is precies 180 graden, en 135 is kleiner. Onthoud: gestrekt = 180 graden = een rechte lijn."
        }
      }
    },
    {
      "id": "MET-HOEK-SOORTEN-003",
      "familyId": "MET-HOEK-SOORTEN",
      "module": "Metriek",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "hoeken",
      "subSkill": "hoek_soorten",
      "questionType": "multiple_choice",
      "question": "Een draaischijf in een fabriek draait een kwart slag. Hoeveel graden is dat? En wat voor soort hoek ontstaat er?",
      "options": ["180° — een gestrekte hoek", "90° — een rechte hoek", "360° — een volle draai", "45° — een scherpe hoek"],
      "correctAnswer": 1,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Draaien in graden",
            "content": "Een volle draai = 360°.\nKwart draai = 360° ÷ 4 = 90° (rechte hoek)\nHalve draai = 360° ÷ 2 = 180° (gestrekte hoek)\nDriekwart draai = 270°",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "hoek_draai_kwart",
      "variantIndex": 3,
      "citoDifficulty": 0.32,
      "citoDiscrimination": 0.73,
      "feedback": {
        "explanationText": "Een volle draai is 360°. Een kwart daarvan is 360° ÷ 4 = 90°. Een hoek van 90° is een rechte hoek. Je kunt het onthouden door te denken aan een klok: van 12 naar 3 is een kwart draai = 90°. Controleer: kwart van 360° = 90° ✓.",
        "solutionSteps": [
          "Een volle draai = 360°",
          "Een kwart slag = 360° ÷ 4 = 90°",
          "90° = rechte hoek",
          "Controleer: van 12 naar 3 op de klok = kwart draai = 90° ✓"
        ],
        "distractorExplanations": {
          "0": "Je dacht waarschijnlijk dat een kwart draai 180 graden is. Maar 180 is een halve draai (gestrekte hoek). Een kwart draai = 360 / 4 = 90. Onthoud: kwart = 90, half = 180.",
          "1": "Goed! Een kwart draai = 360 / 4 = 90 graden, en dat is een rechte hoek.",
          "2": "Je dacht waarschijnlijk dat een kwart draai 360 graden is. Maar 360 is een volle draai. Een kwart daarvan = 360 / 4 = 90. Onthoud: 360 = heel, 90 = kwart.",
          "3": "Je dacht waarschijnlijk dat een kwart draai 45 graden is. Maar 45 is een achtste draai (360 / 8). Een kwart draai = 360 / 4 = 90. Onthoud: kwart = 90."
        }
      }
    },
    {
      "id": "MET-HOEK-SOORTEN-004",
      "familyId": "MET-HOEK-SOORTEN",
      "module": "Metriek",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "hoeken",
      "subSkill": "hoek_soorten",
      "questionType": "multiple_choice",
      "question": "Een interieurontwerper bekijkt de hoeken van een kamer. De kamer heeft de vorm van een rechthoek. Wat weet je zeker over de hoeken?",
      "options": ["Twee hoeken zijn scherp en twee zijn stomp", "Alle hoeken zijn stomp", "De hoeken zijn allemaal verschillend", "Alle 4 hoeken zijn 90° (rechte hoeken)"],
      "correctAnswer": 3,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Hoeken in een rechthoek",
            "content": "Een RECHThoek heeft 4 RECHTE hoeken.\nElke hoek is precies 90°.\nTotaal: 4 × 90° = 360° (= volle draai).\nDit geldt ook voor een vierkant (= bijzondere rechthoek).",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "hoek_rechthoek",
      "variantIndex": 4,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "In een rechthoek zijn alle vier de hoeken rechte hoeken van 90°. Dat is precies waarom het een RECHThoek heet — alle hoeken zijn recht. Samen: 4 × 90° = 360°, wat klopt met een volle draai. Onthoud: de naam 'rechthoek' vertelt je al dat de hoeken recht zijn.",
        "solutionSteps": [
          "Een rechthoek heeft 4 hoeken",
          "Alle 4 hoeken zijn 90° (recht)",
          "Totaal: 4 × 90° = 360° (volle draai) ✓",
          "De naam 'RECHThoek' verwijst naar de rechte hoeken"
        ],
        "distractorExplanations": {
          "0": "Je dacht waarschijnlijk aan een parallellogram of ruit. Daar zijn inderdaad twee hoeken scherp en twee stomp. Maar een rechthoek heeft vier gelijke rechte hoeken van 90 graden. Onthoud: RECHThoek = RECHTE hoeken.",
          "1": "Je dacht waarschijnlijk dat alle hoeken stomp zijn. Maar stompe hoeken zijn groter dan 90 graden, en in een rechthoek zijn alle hoeken precies 90. Onthoud: 90 = recht, niet stomp.",
          "2": "Je dacht waarschijnlijk dat de hoeken verschillend zijn. Maar in een rechthoek zijn alle vier de hoeken gelijk: 90 graden. Onthoud: bij een rechthoek zijn alle hoeken hetzelfde.",
          "3": "Goed! Alle hoeken in een rechthoek zijn 90 graden (rechte hoeken)."
        }
      }
    },
    {
      "id": "MET-HOEK-SOORTEN-005",
      "familyId": "MET-HOEK-SOORTEN",
      "module": "Metriek",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "hoeken",
      "subSkill": "hoek_soorten",
      "questionType": "multiple_choice",
      "question": "Een verkeerskundige bekijkt een kruispunt. Twee wegen vormen een hoek van precies 180°. Wat voor soort hoek is dat?",
      "options": ["een stompe hoek", "een rechte hoek", "een gestrekte hoek", "een volle draai"],
      "correctAnswer": 2,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Gestrekte hoek",
            "content": "Een gestrekte hoek is precies 180° — de twee lijnen vormen samen een rechte lijn.\nScherp: < 90° | Recht: = 90° | Stomp: 90°–180° | Gestrekt: = 180° | Vol: = 360°",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "hoek_soorten_gestrekt",
      "variantIndex": 5,
      "citoDifficulty": 0.28,
      "citoDiscrimination": 0.75,
      "feedback": {
        "explanationText": "180° is een gestrekte hoek. De twee wegen vormen samen een rechte lijn. Je kunt het onthouden: 'gestrekt' betekent 'uitgerekt tot een lijn'. Een halve draai (180°) is precies een gestrekte hoek. Controleer: 180° = halve draai = gestrekte hoek ✓.",
        "solutionSteps": [
          "Bekijk het getal: 180°",
          "180° = precies een halve draai",
          "Een halve draai = gestrekte hoek (rechte lijn)",
          "Controleer: de twee wegen vormen een rechte lijn ✓"
        ],
        "distractorExplanations": {
          "0": "Je dacht waarschijnlijk dat 180 graden een stompe hoek is. Een stompe hoek is groter dan 90 maar kleiner dan 180. Precies 180 is gestrekt, niet stomp. Onthoud: stomp = tussen 90 en 180, gestrekt = precies 180.",
          "1": "Je dacht waarschijnlijk dat 180 graden een rechte hoek is. Maar een rechte hoek is 90, niet 180. 180 is het dubbele van een rechte hoek. Onthoud: recht = 90, gestrekt = 180.",
          "2": "Goed! 180 graden is een gestrekte hoek — de twee lijnen vormen een rechte lijn.",
          "3": "Je dacht waarschijnlijk dat 180 graden een volle draai is. Maar een volle draai is 360. 180 is een halve draai = gestrekte hoek. Onthoud: vol = 360, half = 180."
        }
      }
    },
    {
      "id": "MET-HOEK-SOORTEN-006",
      "familyId": "MET-HOEK-SOORTEN",
      "module": "Metriek",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "hoeken",
      "subSkill": "hoek_soorten",
      "questionType": "fill_in",
      "question": "Een hoek van 110° is een ... hoek. Typ het soort (scherp, recht, stomp of gestrekt).",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "acceptedAnswers": ["stomp", "stompe"],
        "caseSensitive": false,
        "placeholder": "... hoek"
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Hoeksoorten overzicht",
            "content": "Scherp: < 90° (spits, kleiner dan een rechte hoek)\nRecht: = 90° (vierkantje in de hoek)\nStomp: > 90° en < 180° (wijd, groter dan recht)\nGestrekt: = 180° (rechte lijn)",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "hoek_soorten_stomp_fill",
      "variantIndex": 6,
      "citoDifficulty": 0.38,
      "citoDiscrimination": 0.71,
      "feedback": {
        "explanationText": "110° is groter dan 90° maar kleiner dan 180°, dus het is een stompe hoek. Stompe hoeken zijn 'wijd' — groter dan een rechte hoek maar nog geen rechte lijn. Controleer: 90° < 110° < 180° → stomp ✓.",
        "solutionSteps": [
          "Bekijk het getal: 110°",
          "110° > 90° → niet scherp en niet recht",
          "110° < 180° → niet gestrekt",
          "Tussen 90° en 180° = stompe hoek ✓"
        ]
      }
    }
  ]
}
